import { FileProcessingStatus } from './file'
import { IFileClassification } from './fileClassification'
import { ISingleFileClassification } from './prospects'

export interface IFileUser {
  id: string
  firstName?: string | null
  lastName?: string | null
  email: string
}

export interface IBoxFileBase {
  id: string
  name: string
  size?: number
  type?: string
}

export interface IFile {
  id: string
  name: string
  fileName?: string
  size?: number
  type?: string
  link?: string
  boxLink?: string
  reportDate?: string
  sheetNames?: string[]
  sheetName?: string
  isSkipped?: boolean
  /** Shown to Dwight users only; the client never receives it. */
  isInternal?: boolean
  fileId?: string
  boxSignInfo?: IBoxSignInfo
  createdAt?: string
  updatedAt?: string
  modifiedAt?: string
  isUploading?: boolean
  // Prospect-portal only: the upload is older than the intake staleness window,
  // so its document type reads as outstanding again and the prospect is asked to
  // re-upload. The file itself is retained and stays visible internally.
  isExpired?: boolean
  error?: string | null
  originalFileId?: string
  processingStatus?: FileProcessingStatus
  preprocessingSummaryMessage?: string | null
  /**
   * The classifier's verdict on this file — what shape it was read as, how it
   * was routed, and why. Either flow's shape; the file-select modal narrows on
   * `layout` to tell them apart.
   */
  preprocessingAssessment?: IFileClassification | ISingleFileClassification | null
  createdByUser?: IFileUser
  state?: string | null
  legalEntityName?: string | null
  legalEntityId?: string | null
  complianceResult?: string | null
  emailId?: string | null
}

export interface IBoxSignInfo {
  id?: string
  requestId?: string
  signStatus?: BoxSignStatus
  embeddedUrl?: string
  requestedAmount?: number
}

export interface IFileSheet {
  id?: string
  fileId: string
  sheetName?: string
  data?: any
  createdAt?: string
}

export interface IGroupedFile {
  file: IFile
  processed: Array<IFile & { fileSheets?: IFileSheet[] }>
  fileSheets: IFileSheet[]
}

export interface IFolder {
  id: string
  name: string
  type?: string
  items?: (IFolder | IFile)[]
}

export interface IFileProcessingError {
  id: string
  fileName: string
  sheetName: string
  error: string
  messagesList?: string[]
  code: string | number
}

export enum BoxSignStatus {
  converting = 'converting',
  created = 'created',
  sent = 'sent',
  viewed = 'viewed',
  signed = 'signed',
  cancelled = 'cancelled',
  declined = 'declined',
  expired = 'expired',
  error_converting = 'error_converting',
  error_sending = 'error_sending',
}

export enum BoxSignStatusLabel {
  CreatingDocument = 'Creating Document',
  SentForSignature = 'Sent for Signature',
  AwaitingSignature = 'Awaiting Signature',
  AwaitingSignatureViewed = 'Awaiting Signature (Viewed)',
  ReadyToFund = 'Ready to Fund',
  Cancelled = 'Cancelled',
  Declined = 'Declined',
  Expired = 'Expired',
  Error = 'Error',
}

export const MANUALLY_SEND_LABEL = 'Manually Send'

export const BOX_SIGN_STATUS_LABEL: Record<BoxSignStatus, BoxSignStatusLabel> = {
  [BoxSignStatus.converting]: BoxSignStatusLabel.CreatingDocument,
  [BoxSignStatus.created]: BoxSignStatusLabel.SentForSignature,
  [BoxSignStatus.sent]: BoxSignStatusLabel.AwaitingSignature,
  [BoxSignStatus.viewed]: BoxSignStatusLabel.AwaitingSignatureViewed,
  [BoxSignStatus.signed]: BoxSignStatusLabel.ReadyToFund,
  [BoxSignStatus.cancelled]: BoxSignStatusLabel.Cancelled,
  [BoxSignStatus.declined]: BoxSignStatusLabel.Declined,
  [BoxSignStatus.expired]: BoxSignStatusLabel.Expired,
  [BoxSignStatus.error_converting]: BoxSignStatusLabel.Error,
  [BoxSignStatus.error_sending]: BoxSignStatusLabel.Error,
}
